import { Helmet } from 'react-helmet'

import { schemaOrgWebPage, schemaOrgWebSite, stringifyJsonLd } from '../../utils/ld'

import Facebook from './Facebook'
import { SEOProps } from './interface'
import Twitter from './Twitter'

function toTitle(title?: string, defaultTitle?: string) {
  if (defaultTitle) {
    return title ? `${title} : ${defaultTitle}` : defaultTitle
  }
  return title || ''
}

function SEO({
  title,
  // pathname,
  url,
  defaultTitle,
  defaultDescription,
  description,
  siteUrl,
  defaultBanner,
  imageAlt,
  language,
  twitter,
  facebook,
  officialSiteName,
  buildTime,
  canonical,
  disableDefaultDescription,
}: SEOProps) {
  const seo = {
    title: toTitle(title, defaultTitle),
    description: disableDefaultDescription ? description : description || defaultDescription,
    image: `${defaultBanner}`,
    imageAlt,
    url: url || '',
    canonical,
  }
  // og:site_name と WebSite JSON-LD の name の出力ソース
  // 優先順位: officialSiteName（新規・管理画面UI） > facebook（後方互換・YAML/JSON直編集）
  const siteName = officialSiteName || facebook || ''

  return (
    <>
      <Helmet title={seo.title || ''}>
        <html lang={language || 'ja'} />
        {seo.description && <meta name="description" content={seo.description} />}
        <meta name="image" content={seo.image} />
        {seo.canonical && <link rel="canonical" href={seo.canonical} />}
        {/* Insert schema.org data conditionally (webpage/article) + everytime (breadcrumbs) */}
        <script type="application/ld+json">
          {stringifyJsonLd(
            schemaOrgWebPage(url, language, defaultDescription, defaultTitle, buildTime, seo.image)
          )}
        </script>
        {siteName && (
          <script type="application/ld+json">
            {stringifyJsonLd(schemaOrgWebSite(siteName, siteUrl))}
          </script>
        )}
      </Helmet>
      <Facebook
        description={seo.description || ''}
        image={seo.image}
        title={seo.title || ''}
        type={'website'}
        url={seo.url}
        imageAlt={seo.imageAlt}
        siteName={siteName}
      />
      <Twitter
        title={seo.title || ''}
        image={seo.image}
        description={seo.description || ''}
        username={twitter || ''}
      />
    </>
  )
}
export default SEO
